<template>
	<div>
		<page class="page d-flex justify-center">
			<v-row class="align-conten" justify="center">
				<v-col cols="12" sm="10" md="10" lg="10">
					<v-row>
						<v-col>
							<close-app-logo color="dark" />
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-card-text>
								<h2 class="text-center white--text ">שלום </h2>
								<h3 class="text-center white--text mt-5">אינך מורשה למערכת , אנא פנה למוקד התמיכה
									0בטלפון  52-330-9773</h3>
							</v-card-text>
							<v-card-actions class="d-flex flex-column mt-8">
								<v-row>
									<v-col>
										<v-btn link :href="`/login${search}`" class="btn">
											{{ $t('login') }}
										</v-btn>
									</v-col>
								</v-row>

							</v-card-actions>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</page>
		<div class="background-image" />
	</div>
</template>

<script>
import ProjectModule from "src/store/modules/Project.module";
import CloseAppLogo from "@/components/CloseAppLogo";
import UserModule from "src/store/modules/User.module";


export default {
	components: {
		CloseAppLogo
	},
	data: () => ({
		showError: false,
		disabled: false,
		form: {
			email: "",
			password: ""
		},
		errors: {}
	}),
	computed: {
		auth() {
			return this.$store.state.AuthModule.user;
		},
		search() {
			return location.search;
		},
	},
	async created() {
		const id = this.$route.query.p;
		if (id) {
			await this.$store.dispatch(ProjectModule.types.GET, id);
		}
		// this.setProjectBackgroundImage();
	},
	methods: {
		setProjectBackgroundImage() {
			document.querySelector(".background-image").style.background =
				"url(" + this.project.image + ")";
		},
		async doLogin() {
			window.location = "/oauth/authorize" + this.search;
		},
	}
};
</script>

<style lang="scss" scoped>
@import "./../../sass/generic";

.background-image {
	z-index: -1 !important;
	position: fixed;
	height: 100%;
	width: 100%;
	left: 0;
	top: 0;
	webkit-background-size: cover !important;
	-moz-background-size: cover !important;
	-o-background-size: cover !important;
	background-size: cover !important;
	background-position: center !important;
	background-repeat: no-repeat !important;
	filter: blur(6px);
	-webkit-filter: blur(6px);
	transform: scale(1.03);
}

.page {
	width: 90%;
	margin: auto;
	background-color: $background;

	@include responsive($mobile) {
		max-width: $mobile !important;
		max-height: $mobile-height;
	}

	.project-name {
		&--col {
			padding: 0;

			div {
				height: 40px;
				width: 220px;
				background: #4595cc 0 0 no-repeat padding-box;
				border-radius: 0 0 20px 20px;
				opacity: 1;
			}
		}
	}
}
</style>
